import { Text } from '~/components/ui/Text';
import { VehicleNumberPlateType } from '~/shared';
import flagImg from '../../assets/images/flag.svg';
import { getPlateSlots } from './PreviewClassic.model';
import {
	StyledBgLineBlack,
	StyledBgLineWhite,
	StyledCircle,
	StyledContainer,
	StyledCountryContainer,
	StyledDigit,
	StyledLetter,
	StyledNumberContainer,
	StyledRegion,
	StyledRegionContainer,
	StyledSpace,
	StyledStroke,
} from './PreviewClassic.styled';

const PreviewClassic = ({
	type,
	number,
	region,
}: {
	type: VehicleNumberPlateType;
	number: string;
	region: string;
}) => {
	return (
		<StyledContainer>
			<StyledStroke />
			<StyledBgLineBlack />
			<StyledBgLineWhite />
			<StyledCircle $position="left" />
			<StyledCircle $position="right" />
			<StyledNumberContainer>
				{getPlateSlots(number).map((slot, index) => {
					const node =
						slot.kind === 'digit' ? (
							<StyledDigit key={`d#${index}`}>{slot.value || ' '}</StyledDigit>
						) : (
							<StyledLetter key={`l#${index}`} $letter={slot.value}>
								{slot.value || ' '}
							</StyledLetter>
						);
					if (index === 0 || index === 3) {
						return [node, <StyledSpace key={`s#${index}`} />];
					}
					return node;
				})}
			</StyledNumberContainer>
			<StyledRegionContainer
				style={{ right: type === VehicleNumberPlateType.Classic ? 14 : 19 }}
			>
				<StyledRegion>{region.slice(0, 2)}</StyledRegion>
				<StyledCountryContainer>
					<Text>RUS</Text>
					{type === VehicleNumberPlateType.Classic && <img src={flagImg} />}
				</StyledCountryContainer>
			</StyledRegionContainer>
		</StyledContainer>
	);
};

export { PreviewClassic };
